// import "react-pro-sidebar/dist/css/styles.css";
import { Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router";
import useAuth from "./useAuth";
import { useSelector } from "react-redux";
import UserDropDown from "./UserDropDown";
import { trackButtonClick } from "@/utils/analytics";
import { recentSearchLocalSave } from "./saveSearchLocal";
import { handleSRPLogout } from "@/redux/SRP/srpSlice";
import { markInternalNavigation } from "@/utils/attributionCapture";

const buyDropDown = [
  {
    id: 1,
    name: "All Real Estate Auctions",
    routerPath: "/auctions?listingType=AUCN",
  },
  { id: 2, name: "Bank Owned", routerPath: "/bank-owned" },
  {
    id: 3,
    name: "Hubzu Signature Homes",
    routerPath: "/auctions?sid=signature-seller",
  },
  {
    id: 4,
    name: "Off Market Properties",
    routerPath: "/auctions?sid=offmarket-properties",
  },
  { id: 4, name: "Commercial Properties", routerPath: "/commercial" },
  { id: 5, name: "CWCOT Second Chance", routerPath: "/auctions?listingType=AUCN&category=secondchance"},
  { id: 6, name: "Foreclosure", routerPath: "/foreclosures" },
  { id: 7, name: "Short Sale", routerPath: "/short-sale" },
  { id: 8, name: "Traditional Sale", routerPath: "/traditional-sale" },
];

const sellDropDown = [
  {
    id: 1,
    name: "Residential Properties",
    routerPath: "/sellahomeinanonlineauction",
  },
  { id: 2, name: "Commercial Properties", routerPath: "/sell-commercial" },
];

const MobileMenuContent = () => {
  const { pathname } = useLocation();
  const { isUserLoggedIn, userName, userSignOut } = useAuth();
  const user = useSelector((state) => state.user);
  const globalPopup = useSelector((state) => state.login);
  const savedPreference = useSelector((state) => state.savedPreference);

  const handleSignOut = () => {
    userSignOut({});
    dispatch(handleSRPLogout());
    localStorage.removeItem("recentSearch");
  };
  return (
    <>
      <div className="sidebar-header">
        <Link
          to="/"
          className="sidebar-header-inner"
          onClick={() =>
            trackButtonClick({
              eventName: "mobile_nav_click",
              eventCategory: "Mobile Navigation",
              eventSource: "Mobile Menu Click",
              eventLabel: "Logo",
              eventParams: { nav_item: "Home" },
            })
          }
        >
          <img
            className="nav_logo_img img-fluid mt20"
            src="/assets/images/hubzu-logo.png"
            alt="hubzu-logo.png"
          />
        </Link>
        {/* End .logo */}

        <div
          className="fix-icon"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <span className="flaticon-close"></span>
        </div>
        {/* Mobile Menu close icon */}
      </div>

      {/* End logo */}
      {/* <Sidebar> */}
      <div style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}>
        <Menu>
          <SubMenu
            label="Buy"
            component={<Link to="#" />}
            className={
              buyDropDown.some(
                (page) =>
                  page.routerPath?.split("/")[1] === pathname.split("/")[1]
              )
                ? "parent-menu-active"
                : "inactive-mobile-menu"
            }
          >
            {buyDropDown.map((val, i) => (
              <MenuItem
                key={i}
                component={
                  <Link
                    to={val.routerPath}
                    onClick={() => {
                      recentSearchLocalSave({
                        searchBy: null,
                        value: val.name,
                        searchURI: val?.routerPath,
                        isLoggedIn:
                          user.userEmailId || globalPopup?.isUserSubscribed,
                        isMenu: true,
                      });
                      trackButtonClick({
                        eventName: "mobile_nav_click",
                        eventCategory: "Mobile Navigation",
                        eventSource: "Mobile Menu Click",
                        eventLabel: val.routerPath,
                        eventParams: { nav_item: val.name },
                      });

                      // Mark as internal navigation for SRP page mount tracking
                      markInternalNavigation();
                    }}
                  />
                }
                className={
                  pathname?.split("/")[1] === val.routerPath?.split("/")[1]
                    ? "ui-active"
                    : "inactive-mobile-menu"
                }
              >
                {val.name}
              </MenuItem>
            ))}
          </SubMenu>
          {/* End pages Buy drop down */}

          {/* <MenuItem>
            <div
              onClick={() => navigate("/")}
              className={
                pathname === "/contact" ? "ui-active" : "inactive-mobile-menu"
              }
            >
              Sell
            </div>
          </MenuItem> */}
          <SubMenu
            label="Sell"
            component={<Link to="#" />}
            className={
              sellDropDown.some(
                (page) =>
                  page.routerPath?.split("/")[1] === pathname.split("/")[1]
              )
                ? "parent-menu-active"
                : "inactive-mobile-menu"
            }
          >
            {sellDropDown.map((val, i) => (
              <MenuItem
                key={i}
                component={
                  <Link
                    to={val.routerPath}
                    onClick={() => {
                      trackButtonClick({
                        eventName: "mobile_nav_click",
                        eventCategory: "Mobile Navigation",
                        eventSource: "Mobile Menu Click",
                        eventLabel: val.routerPath,
                        eventParams: { nav_item: val.name },
                      });
                    }}
                  />
                }
                className={
                  pathname?.split("/")[1] === val.routerPath?.split("/")[1]
                    ? "ui-active"
                    : "inactive-mobile-menu"
                }
              >
                {val.name}
              </MenuItem>
            ))}
          </SubMenu>

          <MenuItem
            component={
              <Link
                to="/"
                onClick={() => {
                  trackButtonClick({
                    eventName: "mobile_nav_click",
                    eventCategory: "Mobile Navigation",
                    eventSource: "Mobile Menu Click",
                    eventLabel: "Blog",
                    eventParams: { nav_item: "Blog" },
                  });
                }}
              />
            }
            className={
              pathname === "/contact" ? "ui-active" : "inactive-mobile-menu"
            }
          >
            Blog
          </MenuItem>

          {isUserLoggedIn && (
            <MenuItem
              component={
                <a
                  href="#saved-search"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#ss"
                  onClick={(e) => {
                    e.preventDefault();
                    trackButtonClick({
                      eventName: "mobile_nav_click",
                      eventCategory: "Mobile Navigation",
                      eventSource: "Mobile Menu Click",
                      eventLabel: "Saved",
                      eventParams: { nav_item: "Saved Search" },
                    });
                  }}
                />
              }
              className={
                pathname === "/contact" ? "ui-active" : "inactive-mobile-menu"
              }
            >
              Saved{" "}
              <span className="savedCount">{savedPreference.savedCount}</span>
            </MenuItem>
          )}

          <MenuItem
            component={
              <a
                href="#alerts"
                data-bs-toggle="offcanvas"
                data-bs-target="#alertsSidebarListing"
                aria-controls="alertsSidebarListing"
                onClick={(e) => {
                  e.preventDefault();
                  trackButtonClick({
                    eventName: "mobile_nav_click",
                    eventCategory: "Mobile Navigation",
                    eventSource: "Mobile Menu Click",
                    eventLabel: "Global alerts",
                    eventParams: { nav_item: "Global alerts" },
                  });
                }}
              />
            }
            className={
              pathname === "/contact" ? "ui-active" : "inactive-mobile-menu"
            }
            id="main2"
          >
            Alerts
          </MenuItem>

          {!isUserLoggedIn ? (
            <MenuItem
              component={
                <Link
                  to="/register-sign-in"
                  onClick={() => {
                    trackButtonClick({
                      eventName: "mobile_nav_click",
                      eventCategory: "Mobile Navigation",
                      eventSource: "Mobile Menu Click",
                      eventLabel: "Register/Sign In",
                      eventParams: { nav_item: "Register/Sign In" },
                    });
                  }}
                />
              }
              className={
                pathname === "/register-sign-in"
                  ? "ui-active"
                  : "inactive-mobile-menu"
              }
            >
              <span className="flaticon-user"></span> Register/Sign In
            </MenuItem>
          ) : (
            <SubMenu
              label={<span className="flaticon-user"> {userName}</span>}
              component={<Link to="/my-shopper/myProfile" />}
            >
              <UserDropDown
                userType={user.userType}
                user={user.user}
                tag={"menu"}
              />
              <MenuItem
                className="signout"
                key={"signout"}
                component={<Link to="/" onClick={handleSignOut} />}
              >
                Sign Out
              </MenuItem>
            </SubMenu>
          )}
        </Menu>
      </div>
      {/* </Sidebar> */}

      {/* <Link
          to="/create-listing"
          className="btn btn-block btn-lg btn-thm circle"
          style={{width:'90%',margin:'0px auto'}}
        >
          <span className="flaticon-plus"></span> Create Listing
        </Link> */}
    </>
  );
};

export default MobileMenuContent;
